package br.com.vvrefeicoes.portal.feature.operacional

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.FlowRowScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.layout.AppHorizontalScrollbar
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.MoneyFormatter
import br.com.vvrefeicoes.portal.core.util.MonthCalendar
import br.com.vvrefeicoes.portal.domain.model.PeopleKpis
import br.com.vvrefeicoes.portal.domain.model.PeopleMonth
import br.com.vvrefeicoes.portal.domain.model.PeopleUnit
import br.com.vvrefeicoes.portal.feature.shell.LocalGlobalFilters
import br.com.vvrefeicoes.portal.feature.shell.LocalGlobalPeriod
import com.composables.icons.lucide.ArrowRightLeft
import com.composables.icons.lucide.Banknote
import com.composables.icons.lucide.CircleAlert
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Scale
import com.composables.icons.lucide.ThumbsUp
import com.composables.icons.lucide.TrendingUp
import io.github.koalaplot.core.bar.DefaultBarPlotGroupedPointEntry
import io.github.koalaplot.core.bar.DefaultBarPosition
import io.github.koalaplot.core.bar.GroupedHorizontalBarPlot
import io.github.koalaplot.core.bar.GroupedVerticalBarPlot
import io.github.koalaplot.core.bar.HorizontalBarPlot
import io.github.koalaplot.core.line.LinePlot
import io.github.koalaplot.core.style.LineStyle
import io.github.koalaplot.core.xygraph.CategoryAxisModel
import io.github.koalaplot.core.xygraph.Point
import io.github.koalaplot.core.xygraph.XYGraph
import io.github.koalaplot.core.xygraph.rememberAxisContent
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.operational_people_col_absent_hours
import portalvv.shared.generated.resources.operational_people_col_absenteeism
import portalvv.shared.generated.resources.operational_people_col_absenteeism_percent
import portalvv.shared.generated.resources.operational_people_col_bonus
import portalvv.shared.generated.resources.operational_people_col_effective
import portalvv.shared.generated.resources.operational_people_col_employees
import portalvv.shared.generated.resources.operational_people_col_hires
import portalvv.shared.generated.resources.operational_people_col_night_shift
import portalvv.shared.generated.resources.operational_people_col_overtime
import portalvv.shared.generated.resources.operational_people_col_programmed_hours
import portalvv.shared.generated.resources.operational_people_col_terminations
import portalvv.shared.generated.resources.operational_people_col_turnover
import portalvv.shared.generated.resources.operational_people_col_turnover_percent
import portalvv.shared.generated.resources.operational_people_col_unit
import portalvv.shared.generated.resources.operational_people_empty
import portalvv.shared.generated.resources.operational_people_evolution_absenteeism
import portalvv.shared.generated.resources.operational_people_evolution_bonus
import portalvv.shared.generated.resources.operational_people_evolution_overtime
import portalvv.shared.generated.resources.operational_people_evolution_payroll
import portalvv.shared.generated.resources.operational_people_evolution_payroll_percent
import portalvv.shared.generated.resources.operational_people_evolution_turnover
import portalvv.shared.generated.resources.operational_people_kpi_absenteeism
import portalvv.shared.generated.resources.operational_people_kpi_bonus
import portalvv.shared.generated.resources.operational_people_kpi_liquid_payroll
import portalvv.shared.generated.resources.operational_people_kpi_overtime
import portalvv.shared.generated.resources.operational_people_kpi_turnover
import portalvv.shared.generated.resources.operational_people_kpi_variable_costs
import portalvv.shared.generated.resources.operational_people_legend_employees
import portalvv.shared.generated.resources.operational_people_legend_fopag_variation
import portalvv.shared.generated.resources.operational_people_legend_hires
import portalvv.shared.generated.resources.operational_people_legend_terminations
import portalvv.shared.generated.resources.operational_people_legend_turnover
import portalvv.shared.generated.resources.operational_people_legend_vacancies
import portalvv.shared.generated.resources.operational_people_movements_title
import portalvv.shared.generated.resources.operational_people_payroll_title
import portalvv.shared.generated.resources.operational_people_staff_vacancies_title
import portalvv.shared.generated.resources.operational_people_table_title
import kotlin.math.abs
import kotlin.math.round
import kotlin.math.roundToInt
import kotlin.math.roundToLong

private val KPI_HEIGHT = 96.dp
private val LINE_CHART_HEIGHT = 240.dp

private const val W_UNIT = 2.4f
private const val W_SMALL = 0.95f
private const val W_MEDIUM = 1.2f
private const val W_GAP = 0.5f

private val MIN_TABLE_WIDTH = 1360.dp

private val PAYROLL_COLOR = AppPalette.Primary500
private val EMPLOYEE_COLOR = AppPalette.Primary500
private val VACANCY_COLOR = AppPalette.Warning500
private val HIRES_COLOR = AppPalette.Success500
private val TERMINATION_COLOR = AppPalette.Error500
private val TURNOVER_COLOR = AppPalette.Accent500
private val OVERTIME_COLOR = AppPalette.Warning500
private val BONUS_COLOR = AppPalette.Accent500
private val ABSENTEEISM_COLOR = AppPalette.Error500

@Composable
fun PeopleContent() {
    val controller = rememberPeopleController()
    val filters = LocalGlobalFilters.current
    val period = LocalGlobalPeriod.current

    LaunchedEffect(controller) {
        controller.init()
    }

    LaunchedEffect(period.selection) {
        controller.applyPeriod(period.selection)
    }

    LaunchedEffect(filters.unit, filters.manager, filters.director, filters.units) {
        controller.applyFilter(filters.selectedUnit, filters.selectedManager, filters.selectedDirector, filters.units)
    }

    val snapshot = controller.snapshot
    when {
        controller.loading ->
            Box(
                modifier = Modifier.fillMaxWidth().height(200.dp),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        snapshot == null || snapshot.units.isEmpty() ->
            EmptyState(message = stringResource(Res.string.operational_people_empty))
        else -> {
            PeopleKpis(snapshot.kpis)
            StaffVacanciesCard(snapshot.units)
            LiquidPayrollCard(snapshot.units)
            EvolutionGrid(snapshot.monthly)
            PeopleTable(snapshot.units)
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PeopleKpis(kpis: PeopleKpis) {
    FlowRow(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        maxItemsInEachRow = 3,
    ) {
        PeopleKpiTile(
            icon = Lucide.Banknote,
            iconColor = AppPalette.Primary500,
            iconContainerColor = AppPalette.Primary100,
            label = stringResource(Res.string.operational_people_kpi_liquid_payroll),
            value = money(kpis.fopagCents),
        )
        PeopleKpiTile(
            icon = Lucide.Scale,
            iconColor = AppPalette.Info500,
            iconContainerColor = AppPalette.Info100,
            label = stringResource(Res.string.operational_people_kpi_variable_costs),
            value = money(kpis.variableCostsCents),
        )
        PeopleKpiTile(
            icon = Lucide.ArrowRightLeft,
            iconColor = AppPalette.Accent500,
            iconContainerColor = AppPalette.Accent100,
            label = stringResource(Res.string.operational_people_kpi_turnover),
            value = percentText(kpis.turnoverPercent),
        )
        PeopleKpiTile(
            icon = Lucide.TrendingUp,
            iconColor = AppPalette.Warning500,
            iconContainerColor = AppPalette.Warning100,
            label = stringResource(Res.string.operational_people_kpi_overtime),
            value = money(kpis.overtimeCents),
        )
        PeopleKpiTile(
            icon = Lucide.ThumbsUp,
            iconColor = AppPalette.Success500,
            iconContainerColor = AppPalette.Success100,
            label = stringResource(Res.string.operational_people_kpi_bonus),
            value = money(kpis.bonusCents),
        )
        PeopleKpiTile(
            icon = Lucide.CircleAlert,
            iconColor = AppPalette.Error500,
            iconContainerColor = AppPalette.Error100,
            label = stringResource(Res.string.operational_people_kpi_absenteeism),
            value = percentText(kpis.absenteeismPercent),
        )
    }
}

@Composable
private fun FlowRowScope.PeopleKpiTile(
    icon: ImageVector,
    iconColor: Color,
    iconContainerColor: Color,
    label: String,
    value: String,
) {
    Surface(
        modifier = Modifier.weight(1f).height(KPI_HEIGHT),
        shape = AppShapes.medium,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Surface(
                shape = AppShapes.small,
                color = iconContainerColor,
                modifier = Modifier.size(32.dp),
            ) {
                Box(contentAlignment = Alignment.Center) {
                    Icon(
                        imageVector = icon,
                        contentDescription = null,
                        tint = iconColor,
                        modifier = Modifier.size(16.dp),
                    )
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                Text(
                    text = label,
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = value,
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.SemiBold,
                    color = MaterialTheme.colorScheme.onSurface,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
            }
        }
    }
}

@Composable
private fun StaffVacanciesCard(units: List<PeopleUnit>) {
    ChartCard(
        title = stringResource(Res.string.operational_people_staff_vacancies_title),
        modifier = Modifier.fillMaxWidth(),
    ) {
        SeriesLegend(
            entries =
                listOf(
                    LegendEntry(EMPLOYEE_COLOR, stringResource(Res.string.operational_people_legend_employees)),
                    LegendEntry(VACANCY_COLOR, stringResource(Res.string.operational_people_legend_vacancies)),
                ),
        )
        if (units.isEmpty()) {
            EmptyChart()
        } else {
            val ordered = units.reversed()
            val names = ordered.map { it.unitName }
            val employees = ordered.map { it.employees.toFloat() }
            val vacancies = ordered.map { it.vacancies.toFloat() }
            val maxValue = (employees + vacancies).maxOrNull()?.coerceAtLeast(1f) ?: 1f
            val data =
                names.mapIndexed { index, name ->
                    DefaultBarPlotGroupedPointEntry(
                        i = name,
                        d =
                            listOf(
                                DefaultBarPosition(0f, employees[index]),
                                DefaultBarPosition(0f, vacancies[index]),
                            ),
                    )
                }
            XYGraph(
                gridStyle = br.com.vvrefeicoes.portal.core.ui.chart.NoGridStyle,
                xAxisModel = rememberValueAxis(maxValue, headroom = 1.2f),
                yAxisModel = CategoryAxisModel(names),
                xAxisContent = rememberAxisContent(labels = { value -> Text(value.roundToInt().toString(), style = MaterialTheme.typography.labelSmall) }),
                yAxisContent = rememberAxisContent(labels = { value -> Text(value, style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height((names.size * 56 + 48).dp),
            ) {
                GroupedHorizontalBarPlot(
                    data = data,
                    maxBarGroupWidth = 0.9f,
                    bar = { dataIndex, seriesIndex, value ->
                        val unit = ordered.getOrNull(dataIndex)
                        val tooltip =
                            buildString {
                                append(unit?.unitName.orEmpty())
                                append('\n')
                                append(stringResource(Res.string.operational_people_legend_employees))
                                append(": ")
                                append(unit?.employees ?: 0)
                                append('\n')
                                append(stringResource(Res.string.operational_people_legend_vacancies))
                                append(": ")
                                append(unit?.vacancies ?: 0)
                            }
                        HoverTooltip(text = tooltip) {
                            ValueBar(
                                color = if (seriesIndex == SERIES_EMPLOYEES) EMPLOYEE_COLOR else VACANCY_COLOR,
                                label = compactNumber((value.d.getOrNull(seriesIndex)?.end ?: 0f).toDouble()),
                                horizontal = true,
                            )
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun LiquidPayrollCard(units: List<PeopleUnit>) {
    ChartCard(
        title = stringResource(Res.string.operational_people_payroll_title),
        modifier = Modifier.fillMaxWidth(),
    ) {
        if (units.isEmpty()) {
            EmptyChart()
        } else {
            val ordered = units.reversed()
            val names = ordered.map { it.unitName }
            val values = ordered.map { it.fopagCents.toFloat() / 100f }
            val maxValue = values.maxOrNull()?.coerceAtLeast(1f) ?: 1f
            XYGraph(
                gridStyle = br.com.vvrefeicoes.portal.core.ui.chart.NoGridStyle,
                xAxisModel = rememberValueAxis(maxValue, headroom = 1.2f),
                yAxisModel = CategoryAxisModel(names),
                xAxisContent = rememberAxisContent(labels = { value -> Text(money((value * 100).roundToLong()), style = MaterialTheme.typography.labelSmall) }),
                yAxisContent = rememberAxisContent(labels = { value -> Text(value, style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height((names.size * 40 + 48).dp),
            ) {
                HorizontalBarPlot(
                    xData = values,
                    yData = names,
                    barWidth = 0.6f,
                    bar = { index, _, _ ->
                        val unit = ordered.getOrNull(index)
                        HoverTooltip(text = "${unit?.unitName.orEmpty()} — ${money(unit?.fopagCents ?: 0L)}") {
                            ValueBar(color = PAYROLL_COLOR, label = compactMoney(unit?.fopagCents ?: 0L), horizontal = true)
                        }
                    },
                )
            }
        }
    }
}

private enum class PeopleEvolutionChart {
    ABSENTEEISM,
    BONUS,
    PAYROLL,
    PAYROLL_PERCENT,
    OVERTIME,
    MOVEMENTS,
    TURNOVER,
}

@Composable
private fun EvolutionGrid(monthly: List<PeopleMonth>) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val columns =
            when {
                maxWidth >= 860.dp -> 2
                else -> 1
            }
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
            PeopleEvolutionChart.entries.chunked(columns).forEach { rowCharts ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
                ) {
                    rowCharts.forEach { chart ->
                        EvolutionChartCard(chart = chart, monthly = monthly, modifier = Modifier.weight(1f))
                    }
                    repeat(columns - rowCharts.size) {
                        Spacer(Modifier.weight(1f))
                    }
                }
            }
        }
    }
}

@Composable
private fun EvolutionChartCard(
    chart: PeopleEvolutionChart,
    monthly: List<PeopleMonth>,
    modifier: Modifier,
) {
    val labels = monthly.map { MonthCalendar.shortLabel(it.period) }
    when (chart) {
        PeopleEvolutionChart.ABSENTEEISM ->
            PeopleLineCard(
                title = stringResource(Res.string.operational_people_evolution_absenteeism),
                legend = stringResource(Res.string.operational_people_kpi_absenteeism),
                labels = labels,
                values = monthly.map { it.absenteeismPercent.toFloat() },
                percent = true,
                color = ABSENTEEISM_COLOR,
                modifier = modifier,
            )
        PeopleEvolutionChart.BONUS ->
            PeopleLineCard(
                title = stringResource(Res.string.operational_people_evolution_bonus),
                legend = stringResource(Res.string.operational_people_kpi_bonus),
                labels = labels,
                values = monthly.map { it.bonusCents.toFloat() / 100f },
                percent = false,
                color = BONUS_COLOR,
                modifier = modifier,
            )
        PeopleEvolutionChart.PAYROLL ->
            PeopleLineCard(
                title = stringResource(Res.string.operational_people_evolution_payroll),
                legend = stringResource(Res.string.operational_people_kpi_liquid_payroll),
                labels = labels,
                values = monthly.map { it.fopagCents.toFloat() / 100f },
                percent = false,
                color = PAYROLL_COLOR,
                modifier = modifier,
            )
        PeopleEvolutionChart.PAYROLL_PERCENT ->
            PeopleLineCard(
                title = stringResource(Res.string.operational_people_evolution_payroll_percent),
                legend = stringResource(Res.string.operational_people_legend_fopag_variation),
                labels = labels.drop(1),
                values =
                    monthly.zipWithNext { previous, current ->
                        val base = previous.fopagCents
                        if (base == 0L) 0f else ((current.fopagCents - base).toDouble() * 100.0 / base).toFloat()
                    },
                percent = true,
                color = PAYROLL_COLOR,
                signed = true,
                modifier = modifier,
            )
        PeopleEvolutionChart.OVERTIME ->
            PeopleLineCard(
                title = stringResource(Res.string.operational_people_evolution_overtime),
                legend = stringResource(Res.string.operational_people_kpi_overtime),
                labels = labels,
                values = monthly.map { it.overtimeCents.toFloat() / 100f },
                percent = false,
                color = OVERTIME_COLOR,
                modifier = modifier,
            )
        PeopleEvolutionChart.MOVEMENTS -> HiresTerminationsCard(monthly = monthly, modifier = modifier)
        PeopleEvolutionChart.TURNOVER -> TurnoverEvolutionCard(monthly = monthly, modifier = modifier)
    }
}

@Composable
private fun PeopleLineCard(
    title: String,
    legend: String,
    labels: List<String>,
    values: List<Float>,
    percent: Boolean,
    color: Color,
    signed: Boolean = false,
    modifier: Modifier = Modifier,
) {
    ChartCard(title = title, modifier = modifier) {
        SeriesLegend(entries = listOf(LegendEntry(color, legend)))
        if (labels.isEmpty()) {
            EmptyChart()
        } else {
            val points = labels.mapIndexed { index, label -> Point(label, values[index]) }
            val maxValue = values.maxOrNull()?.coerceAtLeast(1f) ?: 1f
            val yAxis =
                when {
                    signed -> rememberSignedValueAxis(values.minOrNull() ?: 0f, values.maxOrNull() ?: 0f)
                    percent -> rememberPercentAxis()
                    else -> rememberValueAxis(maxValue, headroom = 1.3f)
                }
            val format: (Float) -> String =
                if (signed) {
                    { value -> signedPercentText(value.toDouble()) }
                } else {
                    { value -> axisLabel(value, percent) }
                }
            XYGraph(
                gridStyle = br.com.vvrefeicoes.portal.core.ui.chart.NoGridStyle,
                xAxisModel = CategoryAxisModel(labels),
                yAxisModel = yAxis,
                xAxisContent = rememberAxisContent(labels = { value -> Text(value, style = MaterialTheme.typography.labelSmall) }),
                yAxisContent = rememberAxisContent(labels = { value -> Text(format(value), style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height(LINE_CHART_HEIGHT),
            ) {
                LinePlot(
                    data = points,
                    lineStyle = LineStyle(brush = SolidColor(color), strokeWidth = 2.dp),
                    symbol = { point ->
                        HoverTooltip(text = "${point.x}: ${format(point.y)}") {
                            LinePointLabel(format(point.y), color)
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun HiresTerminationsCard(
    monthly: List<PeopleMonth>,
    modifier: Modifier = Modifier,
) {
    ChartCard(
        title = stringResource(Res.string.operational_people_movements_title),
        modifier = modifier,
    ) {
        if (monthly.isEmpty()) {
            EmptyChart()
        } else {
            val labels = monthly.map { MonthCalendar.shortLabel(it.period) }
            val hires = monthly.map { it.hires.toFloat() }
            val terminations = monthly.map { it.terminations.toFloat() }
            SeriesLegend(
                entries =
                    listOf(
                        LegendEntry(HIRES_COLOR, stringResource(Res.string.operational_people_legend_hires)),
                        LegendEntry(TERMINATION_COLOR, stringResource(Res.string.operational_people_legend_terminations)),
                    ),
            )
            val grouped =
                labels.mapIndexed { index, label ->
                    DefaultBarPlotGroupedPointEntry(
                        i = label,
                        d =
                            listOf(
                                DefaultBarPosition(0f, hires[index]),
                                DefaultBarPosition(0f, terminations[index]),
                            ),
                    )
                }
            val maxMovement = (hires + terminations).maxOrNull()?.coerceAtLeast(1f) ?: 1f
            XYGraph(
                gridStyle = br.com.vvrefeicoes.portal.core.ui.chart.NoGridStyle,
                xAxisModel = CategoryAxisModel(labels),
                yAxisModel = rememberValueAxis(maxMovement, headroom = 1.2f),
                xAxisContent = rememberAxisContent(labels = { value -> Text(value, style = MaterialTheme.typography.labelSmall) }),
                yAxisContent = rememberAxisContent(labels = { value -> Text(value.roundToInt().toString(), style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height(LINE_CHART_HEIGHT),
            ) {
                GroupedVerticalBarPlot(
                    data = grouped,
                    maxBarGroupWidth = 0.6f,
                    bar = { dataIndex, seriesIndex, value ->
                        val month = monthly.getOrNull(dataIndex)
                        val tooltip =
                            buildString {
                                append(value.i)
                                append('\n')
                                append(stringResource(Res.string.operational_people_legend_hires))
                                append(": ")
                                append(month?.hires ?: 0)
                                append('\n')
                                append(stringResource(Res.string.operational_people_legend_terminations))
                                append(": ")
                                append(month?.terminations ?: 0)
                            }
                        HoverTooltip(text = tooltip) {
                            ValueBar(
                                color = if (seriesIndex == SERIES_HIRES) HIRES_COLOR else TERMINATION_COLOR,
                                label = (value.d.getOrNull(seriesIndex)?.end ?: 0f).roundToInt().toString(),
                                horizontal = false,
                            )
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun TurnoverEvolutionCard(
    monthly: List<PeopleMonth>,
    modifier: Modifier = Modifier,
) {
    ChartCard(
        title = stringResource(Res.string.operational_people_evolution_turnover),
        modifier = modifier,
    ) {
        SeriesLegend(entries = listOf(LegendEntry(TURNOVER_COLOR, stringResource(Res.string.operational_people_legend_turnover))))
        if (monthly.isEmpty()) {
            EmptyChart()
        } else {
            val labels = monthly.map { MonthCalendar.shortLabel(it.period) }
            val turnoverPoints = labels.mapIndexed { index, label -> Point(label, monthly[index].turnoverPercent.toFloat()) }
            XYGraph(
                gridStyle = br.com.vvrefeicoes.portal.core.ui.chart.NoGridStyle,
                xAxisModel = CategoryAxisModel(labels),
                yAxisModel = rememberPercentAxis(),
                xAxisContent = rememberAxisContent(labels = { value -> Text(value, style = MaterialTheme.typography.labelSmall) }),
                yAxisContent = rememberAxisContent(labels = { value -> Text(percentText(value.toDouble()), style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height(LINE_CHART_HEIGHT),
            ) {
                LinePlot(
                    data = turnoverPoints,
                    lineStyle = LineStyle(brush = SolidColor(TURNOVER_COLOR), strokeWidth = 2.dp),
                    symbol = { point ->
                        HoverTooltip(text = "${point.x}: ${percentText(point.y.toDouble())}") {
                            LinePointLabel(percentText(point.y.toDouble()), TURNOVER_COLOR)
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun PeopleTable(units: List<PeopleUnit>) {
    val scrollState = rememberScrollState()
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16), verticalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
            Text(
                text = stringResource(Res.string.operational_people_table_title),
                style = MaterialTheme.typography.titleMedium,
            )
            BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
                val tableWidth = maxOf(maxWidth, MIN_TABLE_WIDTH)
                Box(modifier = Modifier.fillMaxWidth().horizontalScroll(scrollState)) {
                    Column(modifier = Modifier.width(tableWidth)) {
                        TableGroupHeader()
                        HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                        TableColumnHeader()
                        HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                        units.forEachIndexed { index, unit ->
                            TableBodyRow(unit)
                            if (index < units.lastIndex) {
                                HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                            }
                        }
                    }
                }
            }
            AppHorizontalScrollbar(
                state = scrollState,
                modifier = Modifier.fillMaxWidth().padding(top = AppSpacing.space4),
            )
        }
    }
}

@Composable
private fun TableGroupHeader() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = AppSpacing.space4),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_unit), W_UNIT, TextAlign.Start)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_employees), W_SMALL, TextAlign.End)
        GapCell()
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_absenteeism), W_SMALL * 3, TextAlign.Center)
        GapCell()
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_turnover), W_SMALL * 4, TextAlign.Center)
        GapCell()
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_overtime), W_MEDIUM, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_night_shift), W_MEDIUM, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_bonus), W_MEDIUM, TextAlign.End)
    }
}

@Composable
private fun TableColumnHeader() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = AppSpacing.space4),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        PeopleHeaderCell("", W_UNIT, TextAlign.Start)
        PeopleHeaderCell("", W_SMALL, TextAlign.End)
        GapCell()
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_programmed_hours), W_SMALL, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_absent_hours), W_SMALL, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_absenteeism_percent), W_SMALL, TextAlign.End)
        GapCell()
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_hires), W_SMALL, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_terminations), W_SMALL, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_effective), W_SMALL, TextAlign.End)
        PeopleHeaderCell(stringResource(Res.string.operational_people_col_turnover_percent), W_SMALL, TextAlign.End)
        GapCell()
        PeopleHeaderCell("", W_MEDIUM, TextAlign.End)
        PeopleHeaderCell("", W_MEDIUM, TextAlign.End)
        PeopleHeaderCell("", W_MEDIUM, TextAlign.End)
    }
}

@Composable
private fun TableBodyRow(unit: PeopleUnit) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        PeopleBodyCell(unit.unitName, W_UNIT, TextAlign.Start)
        PeopleBodyCell(unit.employees.toString(), W_SMALL, TextAlign.End)
        GapCell()
        PeopleBodyCell(unit.programmedHours.toString(), W_SMALL, TextAlign.End)
        PeopleBodyCell(unit.absentHours.toString(), W_SMALL, TextAlign.End)
        PeopleBodyCell(percentText(unit.absenteeismPercent), W_SMALL, TextAlign.End)
        GapCell()
        PeopleBodyCell(unit.hires.toString(), W_SMALL, TextAlign.End)
        PeopleBodyCell(unit.terminations.toString(), W_SMALL, TextAlign.End)
        PeopleBodyCell(unit.effective.toString(), W_SMALL, TextAlign.End)
        PeopleBodyCell(percentText(unit.turnoverPercent), W_SMALL, TextAlign.End)
        GapCell()
        PeopleBodyCell(money(unit.overtimeCents), W_MEDIUM, TextAlign.End)
        PeopleBodyCell(money(unit.nightShiftCents), W_MEDIUM, TextAlign.End)
        PeopleBodyCell(money(unit.bonusCents), W_MEDIUM, TextAlign.End)
    }
}

@Composable
private fun RowScope.PeopleHeaderCell(
    text: String,
    weight: Float,
    align: TextAlign,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        textAlign = align,
        modifier = Modifier.weight(weight).padding(horizontal = AppSpacing.space4),
    )
}

@Composable
private fun RowScope.GapCell() {
    Spacer(Modifier.weight(W_GAP))
}

@Composable
private fun RowScope.PeopleBodyCell(
    text: String,
    weight: Float,
    align: TextAlign,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.bodyMedium,
        color = MaterialTheme.colorScheme.onSurface,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        textAlign = align,
        modifier = Modifier.weight(weight).padding(horizontal = AppSpacing.space4),
    )
}

@Composable
private fun EmptyChart() {
    Text(
        text = "—",
        style = MaterialTheme.typography.bodyMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
    )
}

private fun axisLabel(
    value: Float,
    percent: Boolean,
): String = if (percent) percentText(value.toDouble()) else compactMoney((value * 100).roundToLong())

private fun money(cents: Long): String = "R$ ${MoneyFormatter.formatCents(cents)}"

private fun percentText(value: Double): String {
    val scaled = round(value * 10).toLong()
    return "${scaled / 10},${abs(scaled % 10)}%"
}

private fun signedPercentText(value: Double): String {
    val scaled = round(value * 10).toLong()
    val sign = if (scaled < 0) "-" else ""
    val absolute = abs(scaled)
    return "$sign${absolute / 10},${absolute % 10}%"
}

private const val SERIES_EMPLOYEES = 0
private const val SERIES_HIRES = 0
